import React from 'react';
import {Button, Typography} from '@material-ui/core';
import Image from 'material-ui-image'
import CloseIcon from '@material-ui/icons/Close';
import Logo from './logo';
import { __ } from '../lib/localization';
import Views from '../lib/views';

const Header = (props) => {
    return (
        <div>
            <div
                className={`${props.classes.form__header} ${props.view === Views.smsPrivacyPolicy ? props.classes.header__auto : ''}`}
                style={{background: `linear-gradient(180deg, ${props.initialColor} 10%, ${props.endColor} 100%)`}}
            >
                <Typography className={props.classes.header__text}>
                    {props.children}
                </Typography>
                <Button
                    classes={{root: props.classes.closeCaret__text}}
                    onClick={props.handleCloseLeadbox}
                    aria-label={ __('leadbox_close') }
                >
                    <CloseIcon color="rgba(255,255,255,.5)" style={{fontSize: 28}}/>
                </Button>

                {
                    !props.isHeaderCondensed && <Logo
                        src = {props.logo}
                        {...props}
                    />
                }
            </div>
        </div>
    )
}

export default Header;
